import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `OiIntegration` is an implementation of `AbstractIntegration`
 * for integration with OpenIntegration.
 */
export default class OiIntegration extends AbstractIntegration {
	getName() {
		return "Open Integration";
	}

	routeName() {
		return "oi";
	}

	canHaveLinkedDocuments() {
		return true;
	}

	hasInvoiceSupport() {
		return true;
	}

	isBeta() {
		return false;
	}

	importerCanCreateNewCompany() {
		return false;
	}

	static getType() {
		return "OiIntegration";
	}
}
